import Text from "@/components/Text";
import classes from "./index.module.css";
import { useTranslation } from "@/i18n/client";
import { Product } from "@/types/enumerations";
import { getContractDuration, getCurrentProductName } from "@/utils/product";
import { Process } from "@/types/contract";
import { useContractState } from "@/hooks/useContractState";
import { useEnumerations } from "@/hooks/useEnumerations";

interface ProductInfoProps {
  process: Process;
  commodityName: string;
  product: Product;
}

const ProductInfo = ({ process, commodityName, product }: ProductInfoProps) => {
  const { t } = useTranslation("welcome");
  const { t: tCommon } = useTranslation("common");
  const { contract } = useContractState(true);
  const { products } = useEnumerations();

  const productName = contract ? getCurrentProductName(contract, products) : product.name;

  return (
    <div className={classes.productInfo}>
      <div className={classes.textBox}>
        <Text variant="reading_small" c="neutral.9">
          {t("energy")}
        </Text>
        <Text variant="reading_medium_bold">{commodityName}</Text>
      </div>
      <div className={classes.textBox}>
        <Text variant="reading_small" c="neutral.9">
          {t("tariff")}
        </Text>
        <Text variant="reading_medium_bold">{productName}</Text>
      </div>
      <div className={classes.textBox}>
        <Text variant="reading_small" c="neutral.9">
          {t("period")}
        </Text>
        <Text variant="reading_medium_bold">{getContractDuration(process, product, tCommon)}</Text>
      </div>
    </div>
  );
};

export default ProductInfo;
